import React from 'react';
import { Tab, Responsive } from 'semantic-ui-react';
import NewNonCycleStudentCertificate from './NewNonCycleStudentCertificate';
import PreviousNonCycleStudentCertificates from './PreviousNonCycleStudentCertificates';


export default class NonCycleStudentCertificates extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        const activeRole = localStorage.getItem('activeRole');
        const canIssueDocuments = activeRole.substr(0, 10) === 'Studentska';

        const panes = [
            canIssueDocuments ? {
                menuItem: 'Izdavanje dokumenata',
                render: () => (
                    <Tab.Pane attached={false} as={Responsive}>
                        <NewNonCycleStudentCertificate student={this.props.student} />
                    </Tab.Pane>
                )
            } : null,
            {
                menuItem: 'Izdati dokumenti',
                render: () => (
                    <Tab.Pane attached={false} as={Responsive}>
                        <PreviousNonCycleStudentCertificates
                            nonCycleStudentId={this.props.student.id}
                        />
                    </Tab.Pane>
                )
            }
        ];

        return (
            <div>
                <Tab
                    panes={panes}
                    menu={{
                        secondary: true, pointing: true, color: 'blue', vertical: true, fluid: true, attached: true, tabular: true
                    }}
                    defaultActiveIndex={canIssueDocuments ? 0 : 1}
                    grid={{ paneWidth: 13, tabWidth: 3 }}
                />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/NonCycleStudent/NonCycleStudentDocuments/NonCycleStudentCertificates.js